import styled from 'styled-components';
import { PlayListWrapper } from './components/PlayList/PlayListStyles';
import { LineupListWrapper } from './components/Lineup/LineupList/LineupListStyles';
import { TaggingFlowWrapper } from './components/TaggingFlow/TaggingFlowStyles';
import { MetricsWrapper } from './components/Metrics/MetricsStyles';

export const TaggingPageWrapper = styled.div`
  ${TaggingFlowWrapper} {
    &.tag-catcher-throws-visible {
      height: 91%;
    }

    &.base-runners-visible {
      height: 91%;
    }

    &.base-runners-visible.tag-catcher-throws-visible.fielding-sequence-visible {
      height: 86.5%;
    }
  }
`;

export const HeightWrapper = styled.div`
  height: 66vh;
  max-height: 575px;

  ${PlayListWrapper} {
    height: 100%;
  }
  ${LineupListWrapper} {
    height: 100%;
  }
  ${TaggingFlowWrapper} {
    height: 100%;
  }
  ${MetricsWrapper} {
    height: 100%;
  }
`;
